import { render, staticRenderFns } from "./AdiblarHaqida.vue?vue&type=template&id=5e303c16"
import script from "./AdiblarHaqida.vue?vue&type=script&lang=js"
export * from "./AdiblarHaqida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports